<template>
    <div class="tms-logo-layout">
        <div class="public-page">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-sm-9 col-md-7 col-lg-6 mx-auto">
                        <div class="tw-mt-[5%] tw-p-[5%] tw-text-center">
                            <TmsIcon
                                class="tw-inline-block tw-w-2/3"
                                name="tms-map-logo"
                                alt="Magenta Advertising Platform"
                            />
                        </div>
                    </div>
                </div>
                <div v-if="ISIE" class="row warning-status">
                    <div class="col-12 text-center">
                        <p style="font-size: 120%">It looks like you're using a browser we don't support.</p>
                        <p>
                            Please try using
                            <a href="https://www.google.com/chrome/browser/desktop/index.html">Chrome</a>,
                            <a href="https://www.mozilla.org/en-US/firefox/new/">Firefox</a>,
                            <a href="https://www.microsoft.com/en-us/download/details.aspx?id=48126">Edge</a>, or
                            <a href="https://support.apple.com/downloads/#safari">Safari</a>.
                        </p>
                        <p>
                            If you continue to have problems please contact
                            <a href="mailto:tms-sales@t-mobile.com">tms-sales@t-mobile.com</a> for assistance.
                        </p>
                    </div>
                </div>
                <slot v-else />
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue';

import { TmsIcon } from '@pushspring/common-ui/icons-core';

export default defineComponent({
    name: 'TmsLogoLayout',
    components: { TmsIcon },
    computed: {
        ISIE() {
            let isie = false;
            const ua = window.navigator.userAgent;
            const old_ie = ua.indexOf('MSIE ');
            const new_ie = ua.indexOf('Trident/');

            if (old_ie > -1 || new_ie > -1) {
                isie = true;
            }
            return isie;
        },
    },
});
</script>

<style lang="scss">
.public-page {
    min-height: 100vh;
    min-width: 200px;

    height: auto;
    /* Negative indent footer by its height */
    margin: 0 auto -60px;
    /* Pad bottom by footer height */
    padding: 0 0 60px;
    background-color: #fff;
}
</style>
